import React, { useCallback, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import LayersIcon from "@mui/icons-material/Layers";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Link, useLocation, useParams } from "react-router-dom";
import podetailImage from "../../assests/images/Po details.png";
import summaryImage from "../../assests/images/Summary.png";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import checkcircleImage from "../../assests/images/check-circle.png";
import rejectImage from "../../assests/images/Reject.png";
import { UserObj } from "../../services/localStarage";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Paper from "@mui/material/Paper";
import SupportChat from "../support/chat";
import checkImage from "../../assests/images/check-circle.png";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import topArrow from '../../assests/images/top.png';
import topHighlightArrow from '../../assests/images/top-highlighted.png';
import bottomArrow from '../../assests/images/bottom.png';
import bottomHighlightArrow from '../../assests/images/bottom-highlighted.png';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import P2PDownload from "../common/p2pDownload";
import { grnServices } from "../../services/grnServices";
import _ from "lodash";
import { getSecPermission, isEmptyDash, strToDate,trimString } from "../../constant";
import Tooltip from '@mui/material/Tooltip';
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import TrackOrder from "../common/trackOrder";
import { purchaseOrderServices } from "../../services/purchaseOrderServices";
import ActionBtn from "../common/actionBtn";

const initialColumns = [
  { id: "productNumber", label: "Matrial No", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "totalQuantity", label: "Quantity (UOE)", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "unit", label: "Unit of Entry", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "movementType", label: "Movemnent Type", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "plant", label: "Plant", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "storageLocation", label: "Storage Location", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "stockType", label: "Stock Type", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const style2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "45%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const permissionInit = {
  create: false,
  read: false,
  update: false,
  delete: false,
};

function GrnDetail() {
  const { id } = useParams();
  const [openpopdfpurchasemodal, setOpenPoPdfPurchaseModal] = useState(false);
  const [openpopdfpurchasesuccessmodal, setOpenPoPdfPurchaseSuccessModal] =
    useState(false);
  const [openpopdfpurchaserejectedmodal, setOpenPoPdfPurchaseRejectedModal] =
    useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [downloadEl, setdownloadEl] = React.useState(null);
  const [openasnsubmitsuccessfully, setOpenAsnSubmitSuccessfullys] =
    useState(false);
  const [openasncancelsuccessfully, setOpenAsnCancelSuccessfullys] =
    useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const requestPayloadInitials = {
    pageNumber: 1,
    pageSize: 10,
    sortArray: [],
    searchCriteria: [],
  };
  const [isLoading, setIsLoading] = useState(false);
  // const [selectedFile, setSelectedFile] = useState(null);
  const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
  const [filterText, setFilterText] = useState("");
  const [filterFormData, setFilterFormData] = useState("");
  const [columns, setColumns] = useState(initialColumns);
  const [trackOrderData, setTrackOrderData] = useState("");
  const qcListing = {
    currentPage: 1,
    totalPages: 20,
  }

  const [secGRNPermission, setSecGRNPermission] = useState({
    "GRN_LISTING": permissionInit,
    "GRN_DETAIL": permissionInit,
    "TRACK_ORDER_GRN": permissionInit,
    "DOWNLOAD_GRN": permissionInit,
  });

  const [grnDetails, setGRNDetails] = React.useState({});
  const [productsListing, setProductsListing] = React.useState({
    totalPages: 0,
    currentPage: 1,
    totalItems: 0,
    products: [],
  });

  const [inputPage, setInputPage] = useState(productsListing?.currentPage || 1);
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  useEffect(() => {
    getDetails(id);
    let secGRNPermissionInit = _.cloneDeep(secGRNPermission);
    let obj = {};
    for (let key in secGRNPermissionInit) {
      obj[key] = getSecPermission(key);
    }
    // console.log(obj);
    setSecGRNPermission(obj);
  }, []);

  const handleCloseAlert = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };
  const [GRNPurchaseOrderID, setGRNPurchaseOrderID] = useState("");
  const getDetails = (param) => {
    setIsLoading(true);
    let url = `/${param}`;
    let promise = grnServices.getGRNListing(url);
    promise.then((res) => {
      if (res.data.success === true) {
        setGRNDetails(res.data?.data);
        setGRNPurchaseOrderID(res?.data?.data?.purchaseOrderIds[0]);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    getProductsListing(requestPayload, filterText, filterFormData);
  }, [requestPayload]);

  const getProductsListing = (requestPayloadParam, filterTextParam, formData) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    // const filteredFormData = formData ? Object.entries(formData)
    //   .filter(([key, value]) => value !== '')
    //   .reduce((acc, [key, value]) => {
    //     acc[key] = value;
    //     return acc;
    //   }, {}) : {};
    // if (filteredFormData && Object.keys(filteredFormData).length > 0) {
    //   Object.entries(filteredFormData).forEach(([key, value]) => {
    //     param += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    //   });
    // }

    let promise = grnServices.getGRNProductList(id, param);
    promise.then((res) => {
      if (res.data.success === true) {
        setProductsListing(res?.data?.data);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        // console.log(error);
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };


  const onPaginationChange = (e, value) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageNumber = value;
    setRequestPayload(requestPayloadInit);
    // console.log(requestPayloadInit, value);
  }

  const onPageSizeChange = (e) => {
    let { value } = e.target;
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageSize = value;
    requestPayloadInit.pageNumber = 1;
    setRequestPayload(requestPayloadInit);
    // console.log(requestPayloadInit, value);
  }

  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value === '' || /^[0-9]+$/.test(value)) {
      setInputPage(value);
    }
  };

  const handleInputSubmit = (event) => {
    if (event.key === 'Enter') {
      const page = parseInt(inputPage, 10);
      if (!isNaN(page) && page > 0 && page <= productsListing?.totalPages) {
        onPaginationChange(event, page);
      } else {
        setInputPage(productsListing?.currentPage);
      }
    }
  };
  const [opendocumentattchementmodal, setOpenDocumentAttchementModal] = useState(false);


  const onSortChange = (index, sortBy, sortOrder) => {
    // let newSortLael = (sortOrder == "asc") ? "desc" : "asc";

    let requestPayloadInit = _.cloneDeep(requestPayload);
    let columnsInit = _.cloneDeep(columns);
    let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
    requestPayloadInit.sortArray = [sortBy, newSortLael];
    requestPayloadInit.pageNumber = 1;

    for (let i = 0; i < columnsInit.length; i++) {
      columnsInit[i].sortLabel = "";
      if (i == index) {
        // console.log(i, sortBy, sortOrder);
        columnsInit[i].sortLabel = newSortLael;
      }
    }

    setRequestPayload(requestPayloadInit);
    setColumns(columnsInit);
  }

  const onFilterTextChange = (e) => {
    let { value } = e.target;
    setFilterText(value);
    debouncedSearch(value);
  };

  const onKeyPressHandler = (e) => {
    e.persist();
    if (e.key === "Enter") {
      onFilterSubmit();
    }
  };
  const onFilterSubmit = () => {
    getProductsListing(requestPayload, filterText);
  };

  const debouncedSearch = useCallback(
    _.debounce((searchTerm) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageNumber = 1;
      setRequestPayload(requestPayloadInit);
      // console.log("Debounce: ", searchTerm);

    }, 800),
    []
  );

  const download = Boolean(downloadEl);
  const handleClicks = (event) => {
    setdownloadEl(event.currentTarget);
  };
  const handleCloses = () => {
    setdownloadEl(null);
  };
  const userRole = UserObj ? UserObj?.role?.name : "";
  const reducer = (state, action) => {
    switch (action.type) {
      case "TOGGLE_DRAWER":
        return { ...state, open: action.newOpen };
      default:
        throw new Error(`Unknown action: ${action.type}`);
    }
  };
  const [state, dispatch] = React.useReducer(reducer, { open: false });

  const toggleDrawer = (newOpen) => () => {
    dispatch({ type: "TOGGLE_DRAWER", newOpen });
  };

  const handleTrackOrder = () => {
    setIsLoading(true);
    purchaseOrderServices.getPOTrackOrder(GRNPurchaseOrderID)
      .then(response => {
        if (response?.data?.success == true) {
          toggleDrawer(true)();
          setTrackOrderData(response?.data?.data);
        }
      })
      .catch(error => {
        console.log(error);
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}. ` });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const DrawerList = (
    <TrackOrder steps={trackOrderData} close={() => toggleDrawer(false)()} refresh={() => handleTrackOrder()} />
  );
  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div className="search_filter_outerse ms-auto">
            <div className="search_main">
              <h5>GRN Details</h5>
            </div>
            <div className="create_listing_project">
              {/* <div>
                <Button
                  className="vendor_btn vendor_maine_contents"
                  id="basic-button"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                >
                  <LayersIcon />
                  Action
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuItem onClick={handleClose}>Hold</MenuItem>
                  <MenuItem onClick={handleClose}>Recall</MenuItem>
                  <MenuItem onClick={handleClose}>Cancel ASN</MenuItem>
                  <MenuItem onClick={handleClose}>Request for QC</MenuItem>
                </Menu>
              </div> */}
              <ActionBtn
                  url={``}
                  selectedArr={[id]}
                  type="GRN"
                />
              {(secGRNPermission?.TRACK_ORDER_GRN?.read == true) && <div className="track_order_react_row">                
                <button className="btn btn-outline-secondary" onClick={handleTrackOrder}>Track Order</button>
                <Drawer
                  anchor="right"
                  open={state.open}
                  onClose={toggleDrawer(false)}
                  style={{ zIndex: 99999 }}
                >
                  {DrawerList}
                </Drawer>
              </div>}
              {/* <div>
                <Button
                  className="vendor_btn vendor_maine_contents"
                  id="basic-button"
                  aria-controls={download ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={download ? "true" : undefined}
                  onClick={handleClicks}
                >
                  <FileDownloadIcon />
                  Download
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={downloadEl}
                  open={download}
                  onClose={handleCloses}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuItem onClick={handleCloses}>Header Level Excel</MenuItem>
                  <MenuItem onClick={handleCloses}>
                    Line Item Level Excel
                  </MenuItem>
                  <MenuItem onClick={setOpenPoPdfPurchaseModal}>
                    PO PDF
                  </MenuItem>
                </Menu>
              </div> */}

              {(secGRNPermission?.DOWNLOAD_GRN?.read == true) && <P2PDownload
                url={`/v1/common/grns/download`}
                selectedArr={[id]}
                selectedPOJsonArr={[grnDetails]}
                filterFormData={{grnNumber: grnDetails?.grnNumber}}
                filterText={filterText}
                type="GRN"
              />}
              <Link to="/admin/vendor-grn-listing" style={{ textDecoration: "none" }}>
              <button className="btn btn-danger">Back</button>
              </Link>  
            </div>
          </div>
          <div className="first_podetail_basic_block_level_reacts">
            <div className="lets_react_order_listing_level_buyer">
              <div className="content_react_level_details">
                <img src={podetailImage} alt="" />
                <p className="lets_block_react_details_purchase">
                  GRN Number : <Tooltip title={grnDetails?.grnNumber}> {trimString(grnDetails?.grnNumber, 20)}</Tooltip>
                </p>
              </div>
              <div className="lets_pending_react_body">
                Order Date :<span className="date_solutions">{strToDate(grnDetails?.grnDate)} </span>
                <div className="solution_asen_statsu_pending">
                  Status :<p className="date_solutions_status">{grnDetails?.status}</p>
                </div>
              </div>
            </div>
            <div className="lets_table_buyername_react_suntech">
              <table>
                <tr>
                  <td className="name_asn_details_suntech_react_id">
                    GRN Number (SAP)
                  </td>
                  <td>:</td>
                  <td>
                  <Tooltip title={grnDetails?.grnNumberSap}> {trimString(grnDetails?.grnNumberSap, 20)}</Tooltip>
                  </td>
                </tr>
                <tr>
                  <td className="name_asn_details_suntech_react_id">
                    GRN Date
                  </td>
                  <td>:</td>
                  <td>{strToDate(grnDetails?.grnDate)}</td>
                </tr>
                <tr>
                  <td className="name_asn_details_suntech_react_id">
                    Posting Date
                  </td>
                  <td>:</td>
                  <td>{strToDate(grnDetails?.postingDate)}</td>
                </tr>
                <tr>
                  <td className="name_asn_details_suntech_react_id">
                    Created By
                  </td>
                  <td>:</td>
                  <td>
                  <Tooltip title={grnDetails?.createdBy}> {trimString(grnDetails?.createdBy, 20)}</Tooltip>
                  </td>
                </tr>
                <tr>
                  <td className="name_asn_details_suntech_react_id">Vendor Name</td>
                  <td>:</td>
                  <td className="project_bobt_name_tooltip_wraprow"><Tooltip title={grnDetails?.vendorName}> {trimString(grnDetails?.vendorName, 20)}</Tooltip>
                  </td>
                </tr>
                <tr>
                  <td className="name_asn_details_suntech_react_id">Vendor Number</td>
                  <td>:</td>
                  <td className="project_bobt_name_tooltip_wraprow"><Tooltip title={grnDetails?.vendorCode}> {trimString(grnDetails?.vendorCode, 20)}</Tooltip>
                  </td>
                </tr>
              </table>
              <table>
                <tr>
                  <td className="name_asn_details_suntech_react_id">
                    Gate Entry Detail
                  </td>
                  <td>:</td>
                  <td className="project_bobt_name_tooltip_wraprow"><Tooltip title={grnDetails?.geNumber}> {trimString(grnDetails?.geNumber, 20)}</Tooltip>
                  </td>
                </tr>
                <tr>
                  <td className="name_asn_details_suntech_react_id">
                    Invoice No
                  </td>
                  <td>:</td>
                  <td>
                  <Tooltip title={grnDetails?.invoice}> {trimString(grnDetails?.invoice, 20)}</Tooltip>
                  </td>
                </tr>
                <tr>
                  <td className="name_asn_details_suntech_react_id">
                    Invoice Dates
                  </td>
                  <td>:</td>
                  <td>{strToDate(grnDetails?.invoiceDate)}</td>
                </tr>
                <tr>
                  <td className="name_asn_details_suntech_react_id">
                    Material Receipt Date
                  </td>
                  <td>:</td>
                  <td>{strToDate(grnDetails?.materialReceiptDate)}</td>
                </tr>
                <tr>
                  <td className="name_asn_details_suntech_react_id">
                    Purchase Order No
                  </td>
                  <td>:</td>
                  <td className="project_bobt_name_tooltip_wraprow">
                    <Tooltip title={grnDetails?.poNumber}> {trimString(grnDetails?.poNumber, 20)}</Tooltip>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div className="search_filter_outers_react ms-auto">
            <div className="search_main">
              <div id="custom-search-input">
                <div className="input-group col-md-12">
                  <input
                    type="text"
                    className="form-control input-lg"
                    placeholder="Search here"
                    fdprocessedid="8achb"

                    onChange={onFilterTextChange}
                    value={filterText}
                    onKeyPress={onKeyPressHandler}
                  />
                  <span className="input-group-btn">
                    <button
                      className="btn btn-info btn-lg"
                      type="button"
                      fdprocessedid="trsp06"
                    >
                      <span className="glyphicon glyphicon-search">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-search"
                          viewBox="0 0 16 16"
                        >
                          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                        </svg>
                      </span>
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="listing_main listing_main_dragdropcontext_body" style={{ overflowX: "scroll", marginTop: "-15px" }}>
          <table className="">
          <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                <tr>
                  <th className="vendor_tabels">
                    {/* <input type="checkbox" /> */}
                  </th>
                  {columns.map((column, index) => (<>
                    <th className="vendor_tabels ">
                      <div className="PoDetailTableHeading">
                        <div className="d-flex">
                          <p>{column?.label}</p>
                          {(column.isSort == true) && <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)} className="table-sort-ico">
                            {(column.sortLabel != "asc") && <img src={topArrow} />}
                            {(column.sortLabel == "asc") && <img src={topHighlightArrow} />}
                            {(column.sortLabel != "desc") && <img src={bottomArrow} />}
                            {(column.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                          </span>}
                        </div>
                      </div>
                    </th>
                  </>))}
                </tr>
              </thead>
              <tbody style={{ overflowY: "scroll", width: "200px" }}>
                {productsListing?.products.length < 1 && <>
                  <tr>
                    <td colSpan={5} className="text-center list-no-data">No Data Found</td>
                  </tr>
                </>}
                {productsListing?.products?.map((row, rowIndex) => (
                  <tr key={rowIndex} className="maine_tr_vendor">
                    <td>
                      <input type="checkbox" />
                    </td>
                    {columns.map((column, index) => (<>

                      <td key={index} >
                                 <Tooltip title={row[column.id] || "N/A"}>
                                 {trimString(row[column.id], 20 || "N/A")}
                                 </Tooltip>
                               </td>
                    </>
                    ))}

                  </tr>
                ))}
                {/* <tr className="maine_tr_vendor">
                  <td>
                    <input type="checkbox" />
                  </td>
                  <td className="block_solar">00702</td>
                  <td>100</td>
                  <td>Pieces</td>
                  <td>Receipt</td>
                  <td>Delhi</td>
                  <td>Delhi</td>
                  <td>Unrestricted</td>
                </tr> */}
              </tbody>
            </table>
          </div>
          <div className="lets_pagination_package_listing_react">
            <div className="pagination_select_react_packagelr_detail">
              <select
                className="form-select packagelrlisting from-hs"
                onChange={onPageSizeChange}
                value={requestPayload?.pageSize}
              >
                <option selected="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
              <span className="react_text_showing">
                {` Showing rows ${Number(productsListing?.pageSize) * Number(productsListing?.currentPage - 1) + 1} to ${Number(productsListing?.pageSize) * Number(productsListing?.currentPage - 1) + Number(productsListing?.products?.length)} of ${productsListing?.totalItems}`}
              </span>
            </div>
            <Stack spacing={2}>
              <Pagination
                count={productsListing?.totalPages}
                page={productsListing?.currentPage}
                onChange={(event, page) => {
                  setInputPage(page);
                  onPaginationChange(event, page);
                }}
                renderItem={(item) => {
                  if (item.page === productsListing?.currentPage) {
                    return (
                      <input
                        className="form-control listing_currentpagination"
                        type="text"
                        value={inputPage}
                        onChange={handleInputChange}
                        onKeyDown={handleInputSubmit}
                      
                      />
                    );
                  }
                  return (
                    <PaginationItem
                      className="pagination_react_listings"
                      slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                      {...item}
                    />
                  );
                }}

              // count={5}
              // renderItem={(item) => (
              //   <PaginationItem
              //     className="pagination_react_listings"
              //     slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
              //     {...item}
              //   />
              // )}
              />
            </Stack>
          </div>
          {/* Submit sucessfully Modal  */}
          {/* <Modal
            open={openasnsubmitsuccessfully}
            onClose={() => setOpenAsnSubmitSuccessfullys(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenAsnSubmitSuccessfullys(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="approvel_btn_successfully">
                    <img src={checkcircleImage} alt="" />
                    <p className="profile_react_block">
                      Selected GRN has been "<b>Submited</b>" Successfully
                    </p>
                    <p className="profile_react_blocks">
                      GRN No. :<b> 07001 |</b> GRN Qty : <b>12</b>
                    </p>
                    <button
                      className="view_progresse"
                      onClick={() => setOpenAsnSubmitSuccessfullys(false)}
                    >
                      Ok
                    </button>
                  </div>
                </form>
              </div>
            </Box>
          </Modal> */}
          {/* Cancel sucessfully Modal  */}
          {/* <Modal
            open={openasncancelsuccessfully}
            onClose={() => setOpenAsnCancelSuccessfullys(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenAsnCancelSuccessfullys(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="approvel_btn_successfully">
                    <img src={rejectImage} alt="" />
                    <p className="profile_react_block">
                      Selected GRN has been "<b>Cancel</b>" Successfully
                    </p>
                    <p className="profile_react_blocks">
                      GRN No. :<b> 07001 |</b> GRN Amount : <b>₹35,600 |</b> GRN
                      Qty : <b>12</b>
                    </p>
                    <button
                      className="view_progresse"
                      onClick={() => setOpenAsnCancelSuccessfullys(false)}
                    >
                      Ok
                    </button>
                  </div>
                </form>
              </div>
            </Box>
          </Modal> */}
          {/* PO PDF Modal Buyer Po */}
          {/* <Modal
            open={openpopdfpurchaserejectedmodal}
            onClose={() => setOpenPoPdfPurchaseModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenPoPdfPurchaseModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p class="project_Manager_bidding">
                  Are you sure you want to download PO Pdf
                  <br />
                  <b>PO No. : 00701 </b>
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenPoPdfPurchaseModal(false);
                      setOpenPoPdfPurchaseSuccessModal(true);
                    }}
                  >
                    Yes
                  </button>

                  <button
                    href="onboarding_status.html"
                    className="view_lsting"
                    onClick={() => {
                      setOpenPoPdfPurchaseModal(false);
                      setOpenPoPdfPurchaseRejectedModal(true);
                    }}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
          </Modal> */}
          {/* PO PDF Successfully Modal Buyer Po */}

          {/* <Modal
            open={openpopdfpurchasesuccessmodal}
            onClose={() => setOpenPoPdfPurchaseSuccessModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenPoPdfPurchaseSuccessModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={checkImage} alt="" />
                <p class="project_Manager_bidding">
                  Selected PO has been "<b>PDF Download</b>" Successfully
                  <br />
                  <b>PO No. : 07001 </b>
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenPoPdfPurchaseSuccessModal(false);
                    }}
                  >
                    OK
                  </button>
                </div>
              </div>
            </Box>
          </Modal> */}
          {/* <div className="two_btn_cancel_solutions">
            <button
              class="view_failed"
              fdprocessedid="vsrcbk"
              onClick={setOpenAsnCancelSuccessfullys}
            >
              Cancel
            </button>
            <button
              class="view_success"
              fdprocessedid="5m4v4"
              onClick={setOpenAsnSubmitSuccessfullys}
            >
              Submit
            </button>
          </div> */}
        </div>
        
        <SupportChat
          vendorDetails={{ vendor: { _id: grnDetails?.vendorId } }}
          isP2P={true}
          P2PData={{
            isActive: true,
            vendorName: grnDetails?.vendorName,
            refType: "GRN",
            referenceId: grnDetails?._id,
          }}
        />

      </div>

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseAlert}
      />

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => 99999999,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default GrnDetail;
